import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledNumberText = styled.span`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["400"],
        $size: 12,
        $weight: 700,
    })};
`;

export const StyledLabel = styled.span`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["400"],
        $size: 12,
    })};
`;

export const StyledIconContainer = styled.div`
    margin-bottom: 2px;
    margin-right: 8px;

    & ${SWReactIcons} {
        height: 15px;
        width: 15px;
    }
`;

export const StyledContainer = styled.div`
    align-items: center;
    display: flex;
    height: 44px;
    padding-left: 8px;
    padding-right: 8px;
`;
